import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "游戏分类",
    links: [
      { label: "体育竞技", href: "/category/sports" },
      { label: "真人娱乐", href: "/category/live" },
      { label: "电子游艺", href: "/category/slots" },
    ],
  },
  {
    title: "快捷入口",
    links: [
      { label: "优惠资讯", href: "/articles" },
      { label: "关于我们", href: "/about" },
      { label: "联系客服", href: "/about#contact" },
    ],
  },
  {
    title: "帮助中心",
    links: [
      { label: "新手指南", href: "/articles" },
      { label: "常见问题", href: "/#faq" },
      { label: "存款提现", href: "/articles" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-500">
                必赢亚洲
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-sm">
              亚洲顶级娱乐游戏平台，持有合法牌照正规运营。提供体育竞技、真人娱乐、电子游艺等多元玩法，安全存取款，极速到账。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="QQ"
              >
                <i className="ri-qq-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            © 2024 必赢亚洲 版权所有
          </p>
          <p className="text-xs text-background-500">
            理性娱乐，享受健康生活。未满18周岁禁止参与。
          </p>
        </div>
      </div>
    </footer>
  );
}